exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".log-container .el-collapse-item__header {\n  padding-left: 20px;\n}\n.log-user .el-popover__title {\n  font-size: 14px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid #f1f1f1;\n}\n.log-user .popover-content {\n  font-size: 13px;\n  line-height: 1.8;\n  opacity: 0.8;\n}", ""]);

// exports
